import * as types from './constants'

export const changeUserPhoto = payload => ({
  type: types.CHANGE_USER_PHOTO,
  payload
})

export const changeUserPhotoSuccessful = user => ({
  type: types.CHANGE_USER_PHOTO_SUCCESSFUL,
  payload: user
})

export const changeUserPhotoFailure = error => ({
  type: types.CHANGE_USER_PHOTO_FAILURE,
  payload: error
})

export const changeUserEmail = (user, email, translation) => ({
  type: types.CHANGE_USER_EMAIL,
  payload: { user, email, translation }
})

export const changeUserEmailSuccessful = user => ({
  type: types.CHANGE_USER_EMAIL_SUCCESSFUL,
  payload: user
})

export const changeUserEmailFailure = error => ({
  type: types.CHANGE_USER_EMAIL_FAILURE,
  payload: error
})

export const changeUserPassword = (user, password, translation) => ({
  type: types.CHANGE_USER_PASSWORD,
  payload: { user, password, translation }
})

export const changeUserPasswordSuccessful = user => ({
  type: types.CHANGE_USER_PASSWORD_SUCCESSFUL,
  payload: user
})

export const changeUserPasswordFailure = error => ({
  type: types.CHANGE_USER_PASSWORD_FAILURE,
  payload: error
})

export const updateUserData = (user, data, translation) => ({
  type: types.UPDATE_USER_DATA,
  payload: { user, data, translation }
})

export const updateUserDataSuccessful = (user) => ({
  type: types.UPDATE_USER_DATA_SUCCESSFUL,
  payload: user
})

export const updateUserDataFailure = (error) => ({
  type: types.UPDATE_USER_DATA_FAILURE,
  payload: error
})
